export default __webpack_public_path__ + "static/media/footer-playstore.d9f99a11.svg";